import {StoreApi, useStore} from 'zustand';
import {createContext, ReactNode, useContext, useState} from 'react';
import {createFileUploadStore, FileUploadState} from './file-upload-store';
import {useSettings} from '../../core/settings/use-settings';
import {useAuth} from "@common/auth/use-auth";
import {User} from "@common/auth/user";
import {ShareableLink} from "@app/drive/shareable-link/shareable-link";

const FileUploadContext = createContext<StoreApi<FileUploadState>>(null!);

type ExtractState<S> = S extends {
  getState: () => infer T;
}
  ? T
  : never;

type UseFileUploadStore = {
  (): ExtractState<StoreApi<FileUploadState>>;
  <U>(
    selector: (state: ExtractState<StoreApi<FileUploadState>>) => U,
    equalityFn?: (a: U, b: U) => boolean
  ): U;
};

// @ts-ignore
export const useFileUploadStore: UseFileUploadStore = (
  selector,
  equalityFn
) => {
  const store = useContext(FileUploadContext);
  return useStore(store, selector, equalityFn);
};

interface FileUploadProviderProps {
  children: ReactNode;
  owner?: User,
  hash?: string
}
export function FileUploadProvider({children, owner, hash}: FileUploadProviderProps) {
  const settings = useSettings();
  const {user} = useAuth();
  //lazily create store object only once
  const [store] = useState(() => {
    return createFileUploadStore({settings}, owner ?? user, hash);
  });

  return (
    <FileUploadContext.Provider value={store as StoreApi<FileUploadState>}>
      {children}
    </FileUploadContext.Provider>
  );
}
